(function ($) {

    // Size chart mouse move and hover highlighting
    function initTableFeatures() {
        const $container = $('#size-chart-drag');

        if (!$container.length) {
            return;
        }

        const $table = $container.find('table');

        if (!$table.length) {
            return;
        }

        const $cells = $table.find('.table__cell');

        if ($cells.length === 0) {
            return;
        }

        // Drag scroll functionality
        let startY, startX, scrollLeft, scrollTop, isDown = false;

        function handleMouseMove(e) {
            if (!isDown) return;

            e.preventDefault();

            const y = e.pageY - $container.offset().top;
            const walkY = y - startY;
            $container.scrollTop(scrollTop - walkY);

            const x = e.pageX - $container.offset().left;
            const walkX = x - startX;
            $container.scrollLeft(scrollLeft - walkX);
        }

        $container.on('mousedown', function (e) {
            isDown = true;
            startY = e.pageY - $container.offset().top;
            startX = e.pageX - $container.offset().left;
            scrollLeft = $container.scrollLeft();
            scrollTop = $container.scrollTop();

            $(document).on('mousemove', handleMouseMove);
        });

        $(document).on('mouseup', function () {
            isDown = false;
            $(document).off('mousemove', handleMouseMove);
        });

        // Hover highlighting functionality
        $table.on('mouseenter', '.table__cell', function () {
            const $cell = $(this);
            const $row = $cell.closest('.table__row');
            const cellIndex = $cell.index();

            // Add hover-row class to the current row
            $row.addClass('hover-row');

            // Add hover-col class to all cells in the same column
            $table.find('.table__cell').each(function () {
                if ($(this).index() === cellIndex) {
                    $(this).addClass('hover-col');
                }
            });
        });

        $table.on('mouseleave', '.table__cell', function () {
            // Remove all hover classes
            $table.find('.table__row').removeClass('hover-row');
            $table.find('.table__cell').removeClass('hover-col');
        });
    }



    function checkScroll() {
        let $slider = $('#size-chart-drag');
        if (!$slider.length) {
            return;
        }
        const scrollLeft = $slider.scrollLeft();
        const scrollWidth = $slider[0].scrollWidth;
        const clientWidth = $slider[0].clientWidth;

        if (scrollLeft + clientWidth >= scrollWidth - 1) {
            $slider.addClass('-end');
        } else {
            $slider.removeClass('-end');
        }
    }


    $(document).gp_ready(function (){
        initTableFeatures();
        checkScroll();

        if ($('#size-chart-drag').length) {
            $('#size-chart-drag').on('scroll', checkScroll);
        }
    })


    // Retry initialization if container is not found initially
    function retryInit() {
        if ($('#size-chart-drag').length === 0) {
            setTimeout(retryInit, 100);
        } else {
            initTableFeatures();
        }
    }

    // Start retry mechanism after a short delay
    setTimeout(retryInit, 500);


})(jQuery);

